// note: берем из кеша rtkq
import { createSelector } from '@reduxjs/toolkit';
import { getDictionaryByElementProperty } from 'helper';
import { rtkDatasourceTypesSelector } from 'Services/api/datasourceTypesApiTS';

export const datasourceTypesSelector = rtkDatasourceTypesSelector;
export const datasourceTypesDictionarySelector = createSelector(
  datasourceTypesSelector,
  (datasourceTypes) => {
    return getDictionaryByElementProperty(datasourceTypes, 'id');
  },
);
export const datasourceTypesIdsSelector = createSelector(
  datasourceTypesSelector,
  (datasourceTypes) => {
    return datasourceTypes.map(({ id }) => id);
  },
);

export const datasourceTypeSelector = (datasourceTypeId: number) => createSelector(
  [datasourceTypesDictionarySelector],
  (dataSourceTypes) => dataSourceTypes[datasourceTypeId],
);
